<template>
    <div class="downloads-pages">
        <PageTitle icon="mdi-chart-gantt" main="Downloads"
            sub="Cadastros & Cia" />
                    
        <div class="downloads-pages-tabs">
            <v-tabs
            background-color="indigo"
            slider-color="indigo lighten-5"
            v-model="tabActived"
            grow
            center-active
            dark
            icons-and-text
            >
                <v-tab
                    v-for="n in nav.length"
                    :key="n"
                    ripple
                    class="ma-0"
                    >
                    {{ nav[n-1].title }}
                    <v-icon>{{ nav[n-1].icon }}</v-icon>
                </v-tab>
                
                <v-tab-item
                    v-for="n in nav.length"
                    :key="n">
                    <v-card flat>
                        <v-card-text>
                            <keep-alive>
                                <Register 
                                    :title="nav[n-1].title"
                                    :scope="nav[n-1].scope"
                                    :path="nav[n-1].path"
                                    :segment="nav[n-1].segment"
                                    :arrayChilds="nav[n-1].arrayChilds"
                                    :minorScopes="nav[n-1].minorScopes"
                                    :componentHeader="nav[n-1].componentHeader"
                                    :disableNewItem="nav[n-1].disableNewItem"
                                    :enableImport="nav[n-1].enableImport"
                                    :headers="nav[n-1].headers"
                                    :subHeaders="nav[n-1].subHeaders"
                                    :expand="nav[n-1].expand"
                                    :maxWidthForm="nav[n-1].maxWidthForm"
                                    :maxWidthFormImport="nav[n-1].maxWidthFormImport"
                                    :itemModel="nav[n-1].itemModel"
                                    :inputs="nav[n-1].inputs"
                                    :inputsImport="nav[n-1].inputsImport"
                                />
                            </keep-alive>
                        </v-card-text>
                    </v-card>
                </v-tab-item>
            </v-tabs>
        </div>
    </div>
</template>

<script>
import PageTitle from '../templates/PageTitle'
import Register from '../register/Default'
import { createNamespacedHelpers } from 'vuex'
const { mapGetters } = createNamespacedHelpers('downloads')

export default {
    name: 'DownloadsPages',
    components: { PageTitle, Register },
    data: function() {
        return {
            nav: [
                /* Users */
                {
                    title: 'Downloads',
                    icon: "mdi-cloud-download",
                    path: 'downloads',
                    scope: 'downloads',
                    headers: [
                        { text: 'ID', value: '_id', options: { copy: true, slice: -6, toUpperCase: true } },
                        { text: 'Nome', value: 'name', options: {} },
                        { text: 'Arquivos', value: 'files.nickname', options: {vChip: true} },
                        { text: 'Link', value: 'link', align: 'center', options: { link: true, tdClass: 'text-center' } },
                        { text: 'Envios', value: 'sends', align: 'center', options: { tdClass: 'text-center' } },
                        { text: 'Downloads', value: 'downloads', align: 'center', options: { tdClass: 'text-center' } },
                        { text: 'Adicionado em', value: 'createdAt', options: { datePlusWeek: true } },
                        { text: 'Modificado em', value: 'modifiedAt', options: { datePlusWeek: true } },
                        { 
                            text: 'Ações', 
                            value: 'actions', 
                            sortable: false, 
                            align: 'center', 
                            options: { 
                                tdClass: 'text-center', 
                            } 
                        }
                    ],
                    maxWidthForm: 50,
                    inputs: [
                        { 
                            vType: 'v-text-field', 
                            label: 'Nome', 
                            vModel: 'name', 
                            required: true,
                            class: 'xs12 sm12 md12 lg12 xl12', 
                        },
                        { 
                            vType: 'v-file-input', 
                            vModel: 'files', 
                            multiple: false,
                            placeholder: 'Selecione seu Arquivo',
                            required: true, 
                            class: 'xs12 sm12 md12 lg12 xl12'
                        },
                    ]
                },
            ]
        }
    },
    computed: {
        ...mapGetters(['tabActived']),
        
        tabActived: {
			get () {
				return this.$store.state.registers.tabActived
			},
			set (value) {
				this.$store.commit('registers/setTabActived', value)
			}
		},
    },
}
</script>

<style>

</style>